module.exports = __webpack_public_path__ + "media/images/places/ubs-jardim-guarani-c5896a1f7bff42257af8184a647b12ca.jpg";